/* fcx.js — Focus Complex PDP etkileşimleri (galeri, akordiyon, varyant seçimi, sepet) */
(function () {
  'use strict';
  if (window.__fcxLoaded) return;
  window.__fcxLoaded = true;

  var root = document;
  var state = { data: null, variantId: null, plan: 'once', qty: 1 };

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---------------- veri ---------------- */
  function loadData() {
    var el = $('#fcx-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---------------- galeri ----------------
     Ana gorsel alani, parmakla saga/sola kaydirilabilen gercek bir karusele donusturulur.
     Alttaki kucuk gorseller mobilde yatay serit olur ve butun gorseller gorunur. */
  var GALLERY_CSS =
    '.fcx-gallery__main.is-carousel{padding:0;}' +
    '.fcx-gallery__track{position:absolute;inset:0;width:100%;height:100%;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;scrollbar-width:none;-ms-overflow-style:none;}' +
    '.fcx-gallery__track::-webkit-scrollbar{width:0;height:0;display:none;}' +
    '.fcx-gallery__slide{position:relative;flex:0 0 100%;width:100%;height:100%;scroll-snap-align:center;scroll-snap-stop:always;background:repeating-linear-gradient(135deg,#ECE5DA 0 12px,#F4EEE5 12px 24px);}' +
    '.fcx-gallery__slide img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;}' +
    '.fcx-gallery__count{position:absolute;right:12px;bottom:12px;z-index:3;pointer-events:none;background:rgba(11,18,32,.72);color:#fff;font-size:12px;font-weight:600;padding:5px 10px;border-radius:999px;}' +
    '@media (min-width:750px){.fcx-gallery__count{display:none;}}' +
    '@media (max-width:749px){' +
      '.fcx-gallery__thumbs{display:flex!important;flex-wrap:nowrap!important;overflow-x:auto!important;gap:8px!important;scroll-snap-type:x proximity;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none;}' +
      '.fcx-gallery__thumbs::-webkit-scrollbar{width:0;height:0;display:none;}' +
      '.fcx-gallery__thumb{display:block!important;flex:0 0 64px!important;width:64px!important;scroll-snap-align:start;}' +
    '}';

  function injectGalleryCss() {
    if (document.getElementById('fcx-gallery-css')) return;
    var st = document.createElement('style');
    st.id = 'fcx-gallery-css';
    st.textContent = GALLERY_CSS;
    /* Bolum stil dosyasi <body> icinde yuklendigi icin stil en sona eklenir. */
    (document.body || document.head || document.documentElement).appendChild(st);
  }

  function initGallery() {
    var main = $('[data-fcx-gallery-main]');
    if (!main) return;
    var thumbs = $$('[data-fcx-thumb]');
    var baseImg = $('img', main);
    if (!baseImg || thumbs.length < 2) return;

    injectGalleryCss();

    var thumbsWrap = thumbs[0].parentNode;
    var baseSrc = baseImg.getAttribute('src');
    var start = 0;
    thumbs.forEach(function (t, i) { if (t.getAttribute('data-src') === baseSrc) start = i; });

    var track = document.createElement('div');
    track.className = 'fcx-gallery__track';
    track.setAttribute('tabindex', '0');
    track.setAttribute('role', 'group');
    track.setAttribute('aria-label', 'Ürün görselleri — parmağınızla kaydırın');

    var slides = thumbs.map(function (t, i) {
      var slide = document.createElement('div');
      slide.className = 'fcx-gallery__slide';
      var img;
      if (i === start) {
        img = baseImg;
      } else {
        img = document.createElement('img');
        img.setAttribute('src', t.getAttribute('data-src') || '');
        img.setAttribute('alt', t.getAttribute('data-alt') || '');
        img.setAttribute('width', '1400');
        img.setAttribute('height', '1400');
        img.setAttribute('decoding', 'async');
        img.setAttribute('loading', Math.abs(i - start) < 2 ? 'eager' : 'lazy');
      }
      slide.appendChild(img);
      track.appendChild(slide);
      return slide;
    });

    main.appendChild(track);
    main.classList.add('is-carousel');

    var counter = document.createElement('span');
    counter.className = 'fcx-gallery__count';
    counter.setAttribute('aria-hidden', 'true');
    main.appendChild(counter);

    var idx = -1;

    function keepThumbInView(el) {
      if (!thumbsWrap || !el) return;
      if (thumbsWrap.scrollWidth <= thumbsWrap.clientWidth + 1) return;
      var left = el.offsetLeft - thumbsWrap.offsetLeft;
      var right = left + el.offsetWidth;
      if (left < thumbsWrap.scrollLeft) {
        if (thumbsWrap.scrollTo) { thumbsWrap.scrollTo({ left: Math.max(0, left - 8), behavior: 'smooth' }); }
        else { thumbsWrap.scrollLeft = Math.max(0, left - 8); }
      } else if (right > thumbsWrap.scrollLeft + thumbsWrap.clientWidth) {
        var to = right - thumbsWrap.clientWidth + 8;
        if (thumbsWrap.scrollTo) { thumbsWrap.scrollTo({ left: to, behavior: 'smooth' }); }
        else { thumbsWrap.scrollLeft = to; }
      }
    }

    function setActive(i) {
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      if (i === idx) return;
      idx = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      counter.textContent = (i + 1) + ' / ' + slides.length;
      keepThumbInView(thumbs[i]);
    }

    function goTo(i, smooth) {
      if (i < 0) i = slides.length - 1;
      if (i > slides.length - 1) i = 0;
      var left = slides[i].offsetLeft - slides[0].offsetLeft;
      if (smooth === false || !track.scrollTo) { track.scrollLeft = left; }
      else { track.scrollTo({ left: left, behavior: 'smooth' }); }
      setActive(i);
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      var run = function () {
        ticking = false;
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestD = Infinity;
        for (var n = 0; n < slides.length; n++) {
          var c = (slides[n].offsetLeft - slides[0].offsetLeft) + slides[n].offsetWidth / 2;
          var d = Math.abs(c - center);
          if (d < bestD) { bestD = d; best = n; }
        }
        setActive(best);
      };
      if (window.requestAnimationFrame) { requestAnimationFrame(run); } else { setTimeout(run, 60); }
    }, { passive: true });

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); goTo(i); });
    });

    var prev = $('[data-fcx-prev]'), next = $('[data-fcx-next]');
    if (prev) prev.addEventListener('click', function () { goTo(idx - 1); });
    if (next) next.addEventListener('click', function () { goTo(idx + 1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(idx + 1); }
    });

    setActive(start);
    if (start > 0) goTo(start, false);

    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      goTo(idx, false);
    });
  }

  /* ---------------- akordiyon ---------------- */
  function initAccordions() {
    $$('[data-fcx-acc-h]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var panel = btn.parentNode.querySelector('[data-fcx-acc-p]');
        if (panel) { if (open) { panel.setAttribute('hidden', ''); } else { panel.removeAttribute('hidden'); } }
      });
    });
  }

  /* ---------------- fiyat / varyant ---------------- */
  function currentVariant() {
    if (!state.data) return null;
    for (var i = 0; i < state.data.variants.length; i++) {
      if (String(state.data.variants[i].id) === String(state.variantId)) return state.data.variants[i];
    }
    return state.data.variants[0] || null;
  }

  function setText(sel, val) { $$(sel).forEach(function (el) { el.innerHTML = val == null ? '' : val; }); }

  function render() {
    var v = currentVariant();
    if (!v) return;
    var sub = state.plan === 'sub' && v.plan_price;
    var price = sub ? v.plan_price : v.price;
    var compare = sub ? v.price : v.compare;
    var save = sub ? v.plan_save : v.save;

    setText('[data-fcx-price]', price);
    setText('[data-fcx-compare]', compare || '');
    setText('[data-fcx-save]', save || '');
    setText('[data-fcx-sticky-price]', price);
    setText('[data-fcx-sticky-sub]', v.title + (state.plan === 'sub' ? ' · ' + (state.data.labels.sub_short || 'abonelikte') : '') + (state.data.labels.shipping ? ' · ' + state.data.labels.shipping : ''));
    setText('[data-fcx-inst-3]', sub && v.plan_inst ? v.plan_inst['3'] : v.inst['3']);
    setText('[data-fcx-inst-1t]', price);
    ['3', '6', '9'].forEach(function (n) {
      setText('[data-fcx-inst="' + n + '"]', sub && v.plan_inst ? v.plan_inst[n] : v.inst[n]);
      setText('[data-fcx-inst-total="' + n + '"]', price);
    });
    setText('[data-fcx-inst-total="1"]', price);

    var idInput = $('[data-fcx-variant-input]');
    if (idInput) idInput.value = v.id;
    var planInput = $('[data-fcx-plan-input]');
    if (planInput) planInput.value = state.plan === 'sub' && v.selling_plan ? v.selling_plan : '';

    $$('[data-fcx-bundle]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-fcx-bundle')) === String(v.id) ? 'true' : 'false');
    });
    $$('[data-fcx-plan]').forEach(function (p) {
      p.setAttribute('aria-pressed', p.getAttribute('data-fcx-plan') === state.plan ? 'true' : 'false');
    });

    var atc = $$('[data-fcx-atc]');
    atc.forEach(function (b) {
      if (v.available === false) { b.setAttribute('disabled', ''); }
      else { b.removeAttribute('disabled'); }
    });
    setText('[data-fcx-atc-label]', v.available === false
      ? (state.data.labels.soldout || 'Tükendi')
      : (state.plan === 'sub' && state.data.labels.cta_sub ? state.data.labels.cta_sub : state.data.labels.cta));
  }

  function initSelectors() {
    $$('[data-fcx-bundle]').forEach(function (b) {
      b.addEventListener('click', function () { state.variantId = b.getAttribute('data-fcx-bundle'); render(); });
    });
    $$('[data-fcx-plan]').forEach(function (p) {
      p.addEventListener('click', function () {
        if (p.hasAttribute('disabled')) return;
        state.plan = p.getAttribute('data-fcx-plan'); render();
      });
    });
    $$('[data-fcx-jump]').forEach(function (j) {
      j.addEventListener('click', function () {
        var id = j.getAttribute('data-fcx-jump');
        if (id) { state.variantId = id; render(); }
        if (j.hasAttribute('data-fcx-noscroll')) return;
        var hero = $('[data-fcx-hero]');
        if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var toggle = $('[data-fcx-inst-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var t = $('[data-fcx-inst-table]');
        if (!t) return;
        var open = !t.hasAttribute('hidden');
        if (open) { t.setAttribute('hidden', ''); } else { t.removeAttribute('hidden'); }
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }
  }

  /* ---------------- adet ---------------- */
  function initQty() {
    var input = $('[data-fcx-qty-input]');
    if (!input) return;
    $$('[data-fcx-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-fcx-qty-step'), 10) || 1;
        var val = (parseInt(input.value, 10) || 1) + step;
        if (val < 1) val = 1;
        if (val > 99) val = 99;
        input.value = val;
        state.qty = val;
      });
    });
    input.addEventListener('change', function () {
      var val = parseInt(input.value, 10) || 1;
      if (val < 1) val = 1;
      input.value = val;
      state.qty = val;
    });
  }

  /* ---------------- sepete ekle ---------------- */
  function msg(text, isError) {
    $$('[data-fcx-atc-msg]').forEach(function (el) {
      el.textContent = text || '';
      if (isError) { el.setAttribute('data-error', ''); } else { el.removeAttribute('data-error'); }
    });
  }

  /* Sepetle ilgili bölümlerin kimliklerini topla (Section Rendering API için). */
  function cartSectionIds() {
    var map = {};
    $$('cart-items-component[data-section-id], cart-icon-component[data-section-id], cart-bubble[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id) map[id] = 1;
    });
    $$('cart-drawer-component, cart-icon-component, cart-items-component').forEach(function (el) {
      var host = el.closest ? el.closest('[id^="shopify-section-"]') : null;
      if (host && host.id) map[host.id.slice(16)] = 1;
    });
    return Object.keys(map);
  }

  /* Horizon'un beklediği biçimde cart:update olayı gönder.
     Önemli: detail.data mutlaka olmalı, aksi halde cart-items-component çöküyor. */
  function notifyCart(cart, sections, variantId) {
    var ev;
    try { ev = new Event('cart:update', { bubbles: true }); }
    catch (e) { ev = document.createEvent('Event'); ev.initEvent('cart:update', true, false); }
    ev.detail = {
      resource: cart || null,
      sourceId: 'fcx',
      data: {
        source: 'fcx',
        itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : undefined,
        variantId: variantId ? String(variantId) : undefined,
        sections: sections || {}
      }
    };
    document.dispatchEvent(ev);
  }

  function openCart() {
    var drawer = document.querySelector('cart-drawer-component, cart-drawer, #cart-drawer');
    if (!drawer) return false;
    try {
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
    } catch (e) { return false; }
    return false;
  }

  function initAtc() {
    $$('[data-fcx-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.hasAttribute('disabled')) return;
        var forced = btn.getAttribute('data-fcx-variant');
        if (forced) { state.variantId = forced; render(); }
        var v = currentVariant();
        if (!v) return;
        var item = { id: v.id, quantity: state.qty };
        if (state.plan === 'sub' && v.selling_plan) item.selling_plan = v.selling_plan;
        btn.setAttribute('data-busy', '');
        msg(state.data.labels.adding || '');

        var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var payload = { items: [item] };
        var ids = cartSectionIds();
        if (ids.length) {
          payload.sections = ids.join(',');
          payload.sections_url = window.location.pathname;
        }

        fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        }).then(function (added) {
          var sections = (added && added.sections) || null;
          return fetch(routeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; })
            .then(function (cart) { return { cart: cart, sections: sections }; });
        }).then(function (out) {
          btn.removeAttribute('data-busy');
          msg(state.data.labels.added || '');

          if (!document.querySelector('cart-drawer-component, cart-drawer, #cart-drawer')) {
            try { notifyCart(out.cart, out.sections, item.id); } catch (e) { }
            setTimeout(function () { window.location.href = routeRoot + 'cart'; }, 400);
            return;
          }

          /* Horizon'a haber ver. Tema ayarında "sepete eklenince çekmeceyi aç"
             açıksa (auto-open), çekmeceyi Horizon'un kendisi açar — en sağlıklı yol. */
          var autoOpen = !!document.querySelector('cart-drawer-component[auto-open]');
          try { notifyCart(out.cart, out.sections, item.id); } catch (e) { }

          function drawerOpen() {
            var dlg = document.querySelector('cart-drawer-component dialog, dialog.cart-drawer');
            return !!(dlg && dlg.open);
          }

          if (autoOpen) return;

          /* auto-open kapalıysa kendimiz açmayı deneriz, olmazsa sepet sayfasına gideriz. */
          setTimeout(function () { if (!drawerOpen()) openCart(); }, 320);
          setTimeout(function () { if (!drawerOpen()) openCart(); }, 800);
          setTimeout(function () {
            if (!drawerOpen()) window.location.href = routeRoot + 'cart';
          }, 1600);
        }).catch(function () {
          btn.removeAttribute('data-busy');
          msg(state.data.labels.error || '', true);
          setTimeout(function () { window.location.href = '/cart'; }, 700);
        });
      });
    });
  }

  /* ---------------- sabit çubuk + animasyon ---------------- */
  function initSticky() {
    var bar = $('[data-fcx-sticky]');
    var hero = $('[data-fcx-hero]');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px' }).observe(hero);
  }

  function initRise() {
    var els = $$('.fcx-rise');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- başlat ---------------- */
  function init() {
    state.data = loadData();
    initGallery();
    initAccordions();
    initRise();
    initSticky();
    if (state.data) {
      state.variantId = state.data.selected || (state.data.variants[0] && state.data.variants[0].id);
      state.plan = state.data.default_plan || 'once';
      initSelectors();
      initQty();
      initAtc();
      render();
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
